// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/2290994c02ec6c675d33.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"e026ca96cc62db4e362d","166":"93d52b970c5889745729","167":"e6d12d55f7e64411e5ba"}[chunkId] + ".chunk.js";
};